import { createSlice } from '@reduxjs/toolkit'
import gqlCaller from 'graphql/gqlcaller'
import { CreateLead } from 'models/CreateLeadModel'
import {
  AppVersionDetail,
  City,
  CountryState,
  GstMccResponse,
  GstResponse,
  PanDetailsResponse,
  PanGstResponse,
} from 'types/responsetypes'
import { DigilockerDataModel } from 'models/DigiLockerDataModel'
import { consoleLog } from 'utils/Logger'
import { getMccDetailFromCode } from 'utils/businessutil'
import { getCookie } from 'utils/cokie'
import { clearOfficerDraftCache } from 'utils/officer-draft-cache'
import { MCCList, SEDetails } from 'utils/fakeres/Res'
import { OpprtunityModel } from 'models/OpportunityModel'
import { DeploymentModel as MultistoreDeploymentModel } from 'models/DeploymentMultiResponsemodel'
import { MandateStatusModel } from 'models/MandateStatusModel'
import { is3PAgentLoggedIn, isMiniFlow, OwnershipType } from 'pages/home/data'
import { DeploymentModel } from 'models/DeploymentResponsemodel'
const isToken: boolean = getCookie('refresh_token') === null ? false : true
consoleLog('istoken=' + isToken)
consoleLog('istoken=' + getCookie('refresh_token'))

type initialStateType = {
  panGstDetails: PanGstResponse
  panDetails: PanDetailsResponse
  gstDetails: GstResponse
  isApiLoading: boolean
  mccList: MCCList
  createLeadData: CreateLead
  selectedLeadId: string
  selectedOppId: string
  ownerShipType: OwnershipType
  seDetails: SEDetails
  mccDetailsFromGst: GstMccResponse
  mccMapping: Array<any>
  aadharData: DigilockerDataModel
  stepNumber: number
  countryStateList: Array<CountryState>
  cityList: Array<City>
  opportunityDetail: OpprtunityModel
  uploadImgDetail: any
  uploadImageCaptureDetail: any
  deploymentData: DeploymentModel
  multistoreDeploymentData: MultistoreDeploymentModel
  mandateStatus: MandateStatusModel
  appVersionDetail: AppVersionDetail
  storeList: any
  is3PAgent: boolean
  isMiniFlow: boolean
  hasUPIError: boolean
  uenNumber: string
}
const initialState = {
  panGstDetails: null,
  panDetails: null,
  gstDetails: null,
  isApiLoading: false,
  mccList: null,
  createLeadData: {},
  seDetails: null,
  mccDetailsFromGst: null,
  mccMapping: [],
  selectedLeadId: localStorage.getItem('id'),
  selectedOppId: localStorage.getItem('oppId'),
  ownerShipType: localStorage.getItem('firmtype'),
  aadharData: null,
  stepNumber: 0,
  countryStateList: [],
  cityList: [],
  opportunityDetail: null,
  uploadImgDetail: {
    imgName: null,
    imgUrl: null,
  },
  uploadImageCaptureDetail: {
    selfie: {
      imgName: null,
      imgUrl: null,
    },
    stock: {
      imgName: null,
      imgUrl: null,
    },
    shop: {
      imgName: null,
      imgUrl: null,
    },
    shopPhotos: [],
    operating: {
      imgName: null,
      imgUrl: null,
    },
    pan: {
      imgName: null,
      imgUrl: null,
    },
    cheque: {
      imgName: null,
      imgUrl: null,
    },
    form: {
      imgName: null,
      imgUrl: null,
    },
  },
  deploymentData: null,
  mandateStatus: null,
  appVersionDetail: null,
  is3PAgent: is3PAgentLoggedIn(),
  isMiniFlow: isMiniFlow(),
  hasUPIError: false,
  uenNumber: null,
} as initialStateType

export const leadSlice = createSlice({
  name: 'lead',
  initialState: initialState,
  reducers: {
    getPanGstInfo: (state, action) => {
      state.panGstDetails = action.payload
    },
    panDetails: (state, action) => {
      state.panDetails = action.payload
    },
    gstDetails: (state, action) => {
      state.gstDetails = action.payload
    },
    mccList: (state, action) => {
      state.mccList = action.payload
    },
    seDetails: (state, action) => {
      state.seDetails = action.payload
    },
    mccDetailsFromGst: (state, action) => {
      state.mccDetailsFromGst = action.payload
    },
    mccMapping: (state, action) => {
      state.mccMapping = action.payload
    },
    apiStatus: (state, action) => {
      state.isApiLoading = action.payload
    },
    apiCreateLead: (state, action) => {
      state.createLeadData = action.payload.createLead
    },
    setSelectedLeadId: (state, action) => {
      if ((state.selectedLeadId || '') !== (action.payload.leadId || '')) {
        clearOfficerDraftCache()
      }
      state.selectedLeadId = action.payload.leadId
      consoleLog('create lead id dispatch=' + action.payload.leadId)
      // if id is null then we can't store null, null is getting stored as string
      // and null is becoming valid id hence marking as empty so if lead id is empty then
      // our logic will pick opportunity id

      localStorage.setItem('id', action.payload.leadId === null ? '' : action.payload.leadId)
      localStorage.setItem('isRefresh', '')
    },
    setSelectedOppId: (state, action) => {
      state.selectedOppId = action.payload.oppId
      localStorage.setItem('oppId', action.payload.oppId)
      localStorage.setItem('isRefresh', '')
    },
    setExistingMerchant: (state, action) => {
      localStorage.setItem('isExisting', action.payload.isExisting)
    },
    setOwnerShipType: (state, action) => {
      state.ownerShipType = action.payload.ownerShipType
      localStorage.setItem('firmtype', action.payload.ownerShipType)
    },
    setAadharData: (state, action) => {
      state.aadharData = action.payload
    },
    setStepNumer: (state, action) => {
      state.stepNumber = action.payload.stepNumber
    },
    setCountryState: (state, action) => {
      state.countryStateList = action.payload
    },
    setCityList: (state, action) => {
      state.cityList = action.payload
    },
    setOpportunityData: (state, action) => {
      state.opportunityDetail = action.payload
    },
    setUploadImageDetail: (state, action) => {
      state.uploadImgDetail.imgName = action.payload.imgName
      state.uploadImgDetail.imgUrl = action.payload.imgUrl
    },
    setCaptureImageDetail: (state, action) => {
      state.uploadImageCaptureDetail = { ...state.uploadImageCaptureDetail, ...action.payload }
    },
    setDeploymentData: (state, action) => {
      state.deploymentData = action.payload
    },
    setMultistoreDeploymentData: (state, action) => {
      state.multistoreDeploymentData = action.payload
    },
    setMandateStatus: (state, action) => {
      state.mandateStatus = action.payload
    },
    setAppVersion: (state, action) => {
      state.appVersionDetail = action.payload
    },
    setMultistoreData: (state, action) => {
      state.storeList = action.payload
    },
    setUserType: (state, action) => {
      state.is3PAgent = getCookie('user_type') === 'PowerPartner'
    },
    setLeadOrOptyOwner: (state, action) => {
      console.log('setLeadOrOptyOwner = ' + action?.payload)
      localStorage.setItem('opty_owner', action?.payload)
      state.isMiniFlow = isMiniFlow()
    },
    setHasUPIError: (state, action) => {
      state.hasUPIError = action.payload
    },
    setUenNumber: (state, action) => {
      state.uenNumber = action.payload
    },
  },
  extraReducers: (builder) => {
    const clearLocationLists = (state) => {
      state.countryStateList = []
      state.cityList = []
    }
    builder.addCase('auth/getLogin', clearLocationLists)
    builder.addCase('auth/loginError', clearLocationLists)
  },
})
export const getMccList = (gqlQuery) => async (dispatch) => {
  try {
    const { data = {} as MCCList, error = {} } = await gqlCaller({
      gqlQuery: gqlQuery,
      dispatch,
      inputParams: {
        context: { isAuthRequired: true },
      },
      queryId: 1000,
    })
    if (data) {
      localStorage.setItem('mccList', JSON.stringify(data))
      dispatch(mccMapping(getMccDetailFromCode(data.masterMccList)))
      dispatch(mccList(data))
    }
  } catch (err) {
    consoleLog('njvj error display' + err)
  }
}

export const getStateList = (gqlQuery) => async (dispatch) => {
  const tenantId = getCookie('tenantId')
  try {
    const { data, error } = await gqlCaller({
      gqlQuery: gqlQuery,
      dispatch,
      inputParams: {
        context: { isAuthRequired: true },
        fetchPolicy: 'no-cache',
      },
      queryId: 1000,
    })
    if (getCookie('tenantId') === tenantId) {
      dispatch(setCountryState(data?.masterStateList || []))
    }
  } catch (err) {
    consoleLog('getStateList catch error ' + err)
  }
}

export const getCityList = (gqlQuery, stateCode) => async (dispatch) => {
  const tenantId = getCookie('tenantId')
  try {
    const { data, error } = await gqlCaller({
      gqlQuery: gqlQuery,
      dispatch,
      inputParams: {
        variables: {
          input: {
            stateCode,
          },
        },
        context: { isAuthRequired: true },
        fetchPolicy: 'no-cache',
      },
      queryId: 1000,
    })
    // console.log('getCityList = res == ' + JSON.stringify(data))
    // console.log('getCityList = error == ' + JSON.stringify(error))
    if (getCookie('tenantId') === tenantId) {
      dispatch(setCityList(error ? [] : data?.cityList || []))
    }
    return { data, error }
  } catch (err) {
    consoleLog('getCityList error display' + err)
    if (getCookie('tenantId') === tenantId) {
      dispatch(setCityList([]))
    }
    return { data: null, error: err }
  }
}

export const getAppVersion = (gqlQuery) => async (dispatch) => {
  try {
    const { data, error = {} } = await gqlCaller({
      gqlQuery: gqlQuery,
      dispatch,
      inputParams: {
        context: { isAuthRequired: true },
      },
      queryId: 1000,
    })
    dispatch(setAppVersion(data?.salesAppLatestVersion))
  } catch (err) {
    consoleLog('error = ' + err)
  }
}

export const {
  apiStatus,
  getPanGstInfo,
  panDetails,
  gstDetails,
  mccList,
  apiCreateLead,
  setSelectedLeadId,
  seDetails,
  mccDetailsFromGst,
  mccMapping,
  setAadharData,
  setStepNumer,
  setCountryState,
  setCityList,
  setSelectedOppId,
  setOpportunityData,
  setUploadImageDetail,
  setCaptureImageDetail,
  setDeploymentData,
  setMandateStatus,
  setAppVersion,
  setOwnerShipType,
  setMultistoreData,
  setExistingMerchant,
  setMultistoreDeploymentData,
  setUserType,
  setLeadOrOptyOwner,
  setHasUPIError,
  setUenNumber,
} = leadSlice.actions
export const lead = (state) => state.lead
export default leadSlice.reducer
